/* ROULETTE landing (templates/page.lp-roulette.liquid).
   02 The detail and 05 Owners: videos are muted, loop and have no
   controls; each plays only while on screen and pauses when it leaves.
   Reduced motion: it stays on its first frame. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-rlt-autoplay] video').forEach(function (video) {
    video.muted = true;
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('disablepictureinpicture', '');
    if (!video.hasAttribute('aria-label')) video.setAttribute('aria-label', 'The Roulette dial in motion');
    if (reduce && reduce.matches) return;
    function play() {
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { play(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play();
        else video.pause();
      });
    }, { threshold: 0.35 }).observe(video);
  });
})();

/* 03 Finishes (mobile/tablet): the track is a scroll-snap carousel, so swipe
   is native; the arrows and dots scroll it one slide at a time, and the
   finish name, dots and arrow states follow the slide in view. Desktop
   hides the controls (both photos are on screen). */
(function () {
  document.querySelectorAll('[data-rlt-slider]').forEach(function (root) {
    var track = root.querySelector('[data-rlt-track]');
    var slides = root.querySelectorAll('[data-rlt-slide]');
    var name = root.querySelector('[data-rlt-name]');
    var prev = root.querySelector('[data-rlt-prev]');
    var next = root.querySelector('[data-rlt-next]');
    var dots = root.querySelectorAll('[data-rlt-dot]');
    if (!track || slides.length < 2) return;
    var current = -1;

    function go(index) {
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }

    function update() {
      var width = track.clientWidth;
      if (!width) return;
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      if (index === current) return;
      current = index;
      if (name) name.textContent = slides[index].getAttribute('data-name');
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(+dot.getAttribute('data-rlt-dot')); });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { current = -1; update(); });
    update();

    /* Desktop: the inset card (.is-card) swaps places with the main photo
       (.is-main) on click / Enter / Space; both photos fade back in. */
    var desktop = window.matchMedia('(min-width: 990px)');
    var swapTimer = 0;
    function card() { return root.querySelector('[data-rlt-slide].is-card'); }
    function markCard() {
      Array.prototype.forEach.call(slides, function (slide) {
        var isCard = slide.classList.contains('is-card') && desktop.matches;
        if (isCard) {
          slide.setAttribute('role', 'button');
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('aria-label', 'Show ' + slide.getAttribute('data-name'));
        } else {
          slide.removeAttribute('role');
          slide.removeAttribute('tabindex');
          slide.setAttribute('aria-label', slide.getAttribute('data-name'));
        }
      });
    }
    function swap() {
      Array.prototype.forEach.call(slides, function (slide) {
        slide.classList.toggle('is-main');
        slide.classList.toggle('is-card');
      });
      root.classList.remove('rlt-finish--swap');
      void root.offsetWidth;
      root.classList.add('rlt-finish--swap');
      window.clearTimeout(swapTimer);
      swapTimer = window.setTimeout(function () { root.classList.remove('rlt-finish--swap'); }, 700);
      markCard();
      var next = card();
      if (next && document.activeElement && document.activeElement.hasAttribute('data-rlt-slide')) next.focus();
    }
    root.addEventListener('click', function (event) {
      if (!desktop.matches) return;
      var target = event.target.closest('[data-rlt-slide]');
      if (target && target.classList.contains('is-card')) swap();
    });
    root.addEventListener('keydown', function (event) {
      if (!desktop.matches || (event.key !== 'Enter' && event.key !== ' ')) return;
      var target = event.target.closest('[data-rlt-slide]');
      if (!target || !target.classList.contains('is-card')) return;
      event.preventDefault();
      swap();
    });
    if (desktop.addEventListener) desktop.addEventListener('change', markCard);
    markCard();
  });
})();

/* 04 Up close: clicking a macro swaps it with the main photo. Each figure
   keeps its base image URL in data-img; the swap exchanges the URL, the alt
   text and the caption, then gives each image the srcset of its new slot
   (large on the right, small tile).
   No lag: when the section nears the screen, every photo is preloaded in
   both slot sizes; a swap also waits until both new images are decoded
   (usually instant, from cache) before switching, so nothing flashes. */
(function () {
  document.querySelectorAll('[data-rlt-shots]').forEach(function (root) {
    var main = root.querySelector('[data-rlt-shot="main"]');
    var macros = root.querySelectorAll('[data-rlt-shot="macro"]');
    if (!main || !macros.length) return;
    var desktop = window.matchMedia('(min-width: 990px)');
    var timer = 0;
    var busy = false;
    var cache = {};

    function parts(figure) {
      return {
        img: figure.querySelector('.rlt-close__img'),
        source: figure.querySelector('source'),
        cap: figure.querySelector('.rlt-close__cap')
      };
    }
    function widths(url, list) {
      return list.map(function (w) { return url + '&width=' + w + ' ' + w + 'w'; }).join(', ');
    }
    /* What the browser will pick for a slot: the same srcset + sizes the
       slot's <img> / <source> use. */
    function spec(url, large) {
      if (large) {
        return desktop.matches
          ? { srcset: widths(url, [900, 1300, 1800]), sizes: '56vw' }
          : { srcset: widths(url, [480, 750, 1100]), sizes: '100vw' };
      }
      return { srcset: widths(url, [300, 600, 900]), sizes: desktop.matches ? '16vw' : '46vw' };
    }
    function load(url, large) {
      if (!url) return Promise.resolve();
      var key = url + (large ? '|L' : '|S') + (desktop.matches ? 'd' : 'm');
      if (!cache[key]) {
        var img = new Image();
        var s = spec(url, large);
        img.decoding = 'async';
        img.sizes = s.sizes;
        img.srcset = s.srcset;
        cache[key] = (img.decode ? img.decode() : Promise.resolve()).catch(function () {});
      }
      return cache[key];
    }
    function preloadAll() {
      var figures = [main].concat(Array.prototype.slice.call(macros));
      figures.forEach(function (figure) {
        var url = figure.getAttribute('data-img');
        load(url, true);
        load(url, false);
      });
    }
    function paint(figure, url, large) {
      var p = parts(figure);
      if (!p.img || !url) return;
      if (large) {
        if (p.source) p.source.srcset = widths(url, [900, 1300, 1800]);
        p.img.srcset = widths(url, [480, 750, 1100]);
        p.img.src = url + '&width=750';
      } else {
        p.img.srcset = widths(url, [300, 600, 900]);
        p.img.src = url + '&width=600';
      }
      p.img.loading = 'eager';
    }
    function label(figure) {
      var p = parts(figure);
      var name = p.cap ? p.cap.textContent.trim() : '';
      figure.setAttribute('role', 'button');
      figure.setAttribute('tabindex', '0');
      figure.setAttribute('aria-label', 'Show ' + name.charAt(0).toLowerCase() + name.slice(1));
    }
    function apply(macro, mainUrl, macroUrl) {
      var a = parts(main);
      var b = parts(macro);
      var mainAlt = a.img.alt;
      var mainCap = a.cap ? a.cap.textContent : '';
      main.setAttribute('data-img', macroUrl);
      macro.setAttribute('data-img', mainUrl);
      a.img.alt = b.img.alt;
      b.img.alt = mainAlt;
      if (a.cap && b.cap) {
        a.cap.textContent = b.cap.textContent;
        b.cap.textContent = mainCap;
      }
      paint(main, macroUrl, true);
      paint(macro, mainUrl, false);
      label(macro);
      root.classList.remove('rlt-close--swap');
      void root.offsetWidth;
      root.classList.add('rlt-close--swap');
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { root.classList.remove('rlt-close--swap'); }, 400);
    }
    function swap(macro) {
      if (busy) return;
      var a = parts(main);
      var b = parts(macro);
      if (!a.img || !b.img) return;
      var mainUrl = main.getAttribute('data-img');
      var macroUrl = macro.getAttribute('data-img');
      busy = true;
      Promise.all([load(macroUrl, true), load(mainUrl, false)]).then(function () {
        apply(macro, mainUrl, macroUrl);
        busy = false;
      });
    }

    Array.prototype.forEach.call(macros, function (macro) {
      label(macro);
      macro.addEventListener('click', function () { swap(macro); });
      macro.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        swap(macro);
      });
      /* A hover or a touch is a strong hint: warm that photo right away. */
      macro.addEventListener('pointerenter', function () { load(macro.getAttribute('data-img'), true); });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        preloadAll();
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      preloadAll();
    }
  });
})();

/* 05 Owners: multi-card scroll-snap carousel. The arrows move one page
   (what is in view); one dash per page, rebuilt on resize (3 cards per page
   on desktop, 1 on mobile). */
(function () {
  document.querySelectorAll('[data-rlt-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-rlt-ctrack]');
    var prev = root.querySelector('[data-rlt-cprev]');
    var next = root.querySelector('[data-rlt-cnext]');
    var dotsWrap = root.querySelector('[data-rlt-cdots]');
    var cards = track ? track.children : [];
    if (!cards.length) return;
    var pages = 0;
    var perPage = 1;

    /* Cards fully in view at once (1 on mobile, 3 on desktop). */
    function measure() {
      var gap = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft - cards[0].offsetWidth : 0;
      perPage = Math.max(1, Math.floor((track.clientWidth + gap + 2) / (cards[0].offsetWidth + gap)));
      pages = Math.ceil(cards.length / perPage);
    }
    function offsetOf(index) {
      return cards[index].offsetLeft - cards[0].offsetLeft;
    }
    function currentPage() {
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 2) return pages - 1;
      var first = 0;
      for (var i = 0; i < cards.length; i++) {
        if (offsetOf(i) <= track.scrollLeft + 2) first = i;
      }
      return Math.min(pages - 1, Math.round(first / perPage));
    }
    function go(page) {
      track.scrollTo({ left: offsetOf(Math.min(cards.length - 1, page * perPage)), behavior: 'smooth' });
    }
    function buildDots() {
      measure();
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'rlt-own__dot';
        dot.setAttribute('aria-label', 'Show reviews page ' + (i + 1) + ' of ' + pages);
        dot.addEventListener('click', go.bind(null, i));
        dotsWrap.appendChild(dot);
      }
      dotsWrap.hidden = pages < 2;
      update();
    }
    function update() {
      var page = currentPage();
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        if (i === page) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { go(Math.max(0, currentPage() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(pages - 1, currentPage() + 1)); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();

  });
})();

/* 06 Purchase: the strap tabs, finish radios and mobile arrows only ask the
   purchase controller (assets/kt-boltron-purchase.js) for a variant
   (ktb:request-variant); the UI then follows ktb:variant-change, so the
   controller stays the single source of truth (price, ADD TO CART, cart).
   Switching strap keeps the finish position (1st / 2nd). After a
   successful add from here, ADD TO CART shows a check for a moment. */
(function () {
  var root = document.querySelector('[data-rlt-buy]');
  if (!root) return;
  var finishes = Array.prototype.slice.call(root.querySelectorAll('[data-rlt-finish]'));
  var watches = root.querySelectorAll('[data-rlt-watch]');
  var tabs = root.querySelectorAll('[data-rlt-strap]');
  var names = root.querySelectorAll('[data-rlt-name]');
  var sub = root.querySelector('[data-rlt-sub]');

  function request(id) {
    document.dispatchEvent(new CustomEvent('ktb:request-variant', { detail: { variantId: Number(id), source: 'rlt-buy' } }));
  }
  function ofStrap(strap) {
    return finishes.filter(function (f) { return f.getAttribute('data-strap') === strap; });
  }
  function current() {
    var id = root.getAttribute('data-variant-id');
    for (var i = 0; i < finishes.length; i++) {
      if (finishes[i].getAttribute('data-variant-id') === id) return finishes[i];
    }
    return null;
  }

  function sync() {
    var active = current();
    if (!active) return;
    var strap = active.getAttribute('data-strap');
    var key = active.getAttribute('data-rlt-finish');
    root.setAttribute('data-strap', strap);
    finishes.forEach(function (f) {
      var on = f === active;
      f.classList.toggle('is-active', on);
      f.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(watches, function (w) {
      w.classList.toggle('is-active', w.getAttribute('data-rlt-watch') === key);
    });
    Array.prototype.forEach.call(tabs, function (t) {
      var on = t.getAttribute('data-rlt-strap') === strap;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(names, function (n) { n.textContent = active.getAttribute('data-name'); });
    if (sub) sub.textContent = (strap === 'leather' ? 'Leather' : 'Steel') + ' strap · ' + active.getAttribute('data-name');
  }

  finishes.forEach(function (f) {
    f.addEventListener('click', function () { request(f.getAttribute('data-variant-id')); });
  });
  Array.prototype.forEach.call(tabs, function (t) {
    t.addEventListener('click', function () {
      var active = current();
      var list = ofStrap(t.getAttribute('data-rlt-strap'));
      if (!list.length || (active && active.getAttribute('data-strap') === t.getAttribute('data-rlt-strap'))) return;
      var position = active ? Math.max(0, ofStrap(active.getAttribute('data-strap')).indexOf(active)) : 0;
      request(list[Math.min(position, list.length - 1)].getAttribute('data-variant-id'));
    });
  });
  root.querySelectorAll('[data-rlt-step]').forEach(function (button) {
    button.addEventListener('click', function () {
      var active = current();
      if (!active) return;
      var list = ofStrap(active.getAttribute('data-strap'));
      var index = (list.indexOf(active) + Number(button.getAttribute('data-rlt-step')) + list.length) % list.length;
      request(list[index].getAttribute('data-variant-id'));
    });
  });
  document.addEventListener('ktb:variant-change', sync);
  sync();

  /* Add-on options (e.g. the necklace's Gold / Silver): colour swatches
     instead of the shared row's dropdown. The <select> stays (hidden) as
     the controller's source: a swatch sets its value and fires change. */
  var SWATCH = {
    gold: '#D4A017', 'yellow gold': '#D4A017', 'rose gold': '#D9A07A', rose: '#D9A07A',
    silver: '#D3D3D3', steel: '#C9CCCF', black: '#151413', white: '#F4F1EC',
    blue: '#2B4C8C', red: '#B5121B', green: '#0F6A43', brown: '#5A3424'
  };
  root.querySelectorAll('.ktb-addon [data-ktb-addon-variant]').forEach(function (select) {
    var wrap = select.closest('.ktb-addon__variant');
    var row = select.closest('.ktb-addon');
    /* Swatches sit on the price line, so the row keeps the others' height. */
    var meta = row && row.querySelector('.ktb-addon__meta');
    if (!wrap || !meta) return;
    var group = document.createElement('div');
    group.className = 'rlt-buy__swatches';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', (wrap.querySelector('label') || {}).textContent || 'Option');
    var buttons = Array.prototype.map.call(select.options, function (option) {
      var name = option.textContent.replace(/\s*\(unavailable\)\s*$/, '').trim();
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'rlt-buy__swatch';
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-label', name);
      button.title = name;
      button.disabled = option.disabled;
      button.style.setProperty('--rlt-swatch', SWATCH[name.toLowerCase()] || '#8A8580');
      button.addEventListener('click', function (event) {
        /* Inside the row's <label>: never toggle the add-on itself. */
        event.preventDefault();
        event.stopPropagation();
        if (select.disabled || select.value === option.value) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        mark();
      });
      group.appendChild(button);
      return { button: button, option: option };
    });
    /* The row's thumbnail follows the chosen option's own image
       (data-image on the <option>, from the add-on snippet). */
    var thumb = row.querySelector('.ktb-addon__img');
    function mark() {
      buttons.forEach(function (b) {
        var on = b.option.value === select.value;
        b.button.setAttribute('aria-checked', on ? 'true' : 'false');
        var image = b.option.getAttribute('data-image');
        if (on && thumb && image) {
          thumb.removeAttribute('srcset');
          thumb.src = image;
        }
      });
    }
    select.addEventListener('change', mark);
    mark();
    wrap.classList.add('has-swatches');
    meta.appendChild(group);
  });

  var atc = root.querySelector('[data-ktb-atc]');
  var label = atc && atc.querySelector('[data-ktb-atc-label]');
  var timer = 0;
  if (label) {
    document.addEventListener('cart:updated', function () {
      if (!root.classList.contains('is-busy')) return;
      /* The controller resets the label right after this event. */
      window.setTimeout(function () {
        var previous = label.textContent;
        window.clearTimeout(timer);
        atc.classList.add('is-added');
        label.textContent = 'Added';
        timer = window.setTimeout(function () {
          atc.classList.remove('is-added');
          if (label.textContent === 'Added') label.textContent = previous;
        }, 1600);
      }, 0);
    });
  }
})();

/* In-page links (#roulette-buy, #roulette-motion…): a smooth scroll to the
   section instead of a jump. Reduced motion: native jump. */
(function () {
  var root = document.getElementById('roulette-page');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  root.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link || (reduce && reduce.matches)) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
